import React, { useEffect, useState } from "react";
import { api, inr, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const STATUS = { paid: "text-emerald-400 bg-emerald-500/10", pending: "text-amber-400 bg-amber-500/10", failed: "text-red-400 bg-red-500/10", refunded: "text-content-muted bg-card-hover", partially_refunded: "text-content-muted bg-card-hover" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("");
  const load = (s = "") => api.get(`/admin/orders${s ? `?status=${s}` : ""}`).then((r) => setOrders(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const refund = async (id) => {
    if (!window.confirm("Refund this order and revoke access?")) return;
    try { await api.post(`/admin/orders/${id}/refund`, { partial: false }); toast.success("Refunded"); load(filter); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Orders & Payments</h1>
      <div className="flex gap-2 mb-4 flex-wrap">
        {["", "paid", "pending", "failed", "refunded"].map((s) => (
          <button key={s || "all"} onClick={() => { setFilter(s); load(s); }} className={`px-3 py-1.5 rounded-full text-xs border capitalize ${filter === s ? "btn-ember border-transparent" : "border-line bg-card"}`} data-testid={`orders-filter-${s || "all"}`}>{s || "all"}</button>
        ))}
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-line text-left text-content-muted">
            <th className="px-4 py-3 font-medium">Product</th><th className="px-4 py-3 font-medium">Student</th>
            <th className="px-4 py-3 font-medium">Total</th><th className="px-4 py-3 font-medium">Gateway</th>
            <th className="px-4 py-3 font-medium">Status</th><th className="px-4 py-3 font-medium">Date</th><th className="px-4 py-3" />
          </tr></thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-line/50 hover:bg-card-hover/50" data-testid={`admin-order-row-${o.id}`}>
                <td className="px-4 py-3 max-w-xs truncate">{o.product_name}</td>
                <td className="px-4 py-3 text-content-secondary">{o.user_email}</td>
                <td className="px-4 py-3 font-mono">{inr(o.total)}</td>
                <td className="px-4 py-3 text-content-secondary">{o.gateway}{o.simulated ? " (test)" : ""}</td>
                <td className="px-4 py-3"><span className={`text-[11px] px-2 py-0.5 rounded-full capitalize ${STATUS[o.status] || ""}`}>{o.status.replace("_", " ")}</span></td>
                <td className="px-4 py-3 text-content-muted text-xs">{new Date(o.created_at).toLocaleDateString("en-IN")}</td>
                <td className="px-4 py-3 text-right">{o.status === "paid" && <button onClick={() => refund(o.id)} className="text-xs text-red-400" data-testid={`refund-${o.id}`}>Refund</button>}</td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-content-muted">No orders.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
